export const safeJsonParse = (
  value: string | null
): Record<string, any> | undefined => {
  try {
    return JSON.parse(value || '{}')
  } catch (error) {
    return undefined
  }
}
